import { FC } from 'react';
import { Colors, FInter, FlexBox } from '@brg/ui';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';
import { PageViewportLayout } from 'shared/components/template';
import { Spinner } from '@brg/controls';
import { ErrorPage } from 'shared/pages/error/ErrorPage';

export const BookEditFrameError: FC<{ id: string }> = ({ id }) => {
    const { t } = useTranslation();

    return (
        <PageViewportLayout offsetTop={40} justify={'center'} align={'center'}>
            <ErrorPage
                title={t('book_edit.frames.something_went_wrong')}
                text={t('book_edit.frames.cannot_edit')}
            />
        </PageViewportLayout>
    );
};

export const BookFrameError: FC<{ id: string }> = ({ id }) => {
    const { t } = useTranslation();

    return (
        <PageViewportLayout offsetTop={40} justify={'center'} align={'center'}>
            <ErrorPage
                title={t('book_edit.frames.something_went_wrong')}
                text={t('book_edit.frames.undefined')}
            />
        </PageViewportLayout>
    );
};

export const BookEditFrameUpdateError: FC<{ id: string }> = ({ id }) => {
    const { t } = useTranslation();

    return (
        <PageViewportLayout offsetTop={40} justify={'center'} align={'center'}>
            <ErrorPage
                title={t('book_edit.frames.something_went_wrong')}
                text={t('book_edit.frames.update')}
            />
        </PageViewportLayout>
    );
};

export const BookEditFrameLoading: FC<{ id: string }> = ({ id }) => {
    const { t } = useTranslation();
    const theme = useTheme();

    return (
        <PageViewportLayout offsetTop={40} justify={'center'} align={'center'}>
            <FInter.MainTitleMediumDiv color={theme.projectView.titleColor}>
                {t('book_edit.frames.loading')}
            </FInter.MainTitleMediumDiv>
            <FInter.TextFlex offsetTop={16} offsetBottom={16} color={Colors.geoWhite73}>
                {t('book_edit.frames.almost_done')}
            </FInter.TextFlex>
            <Spinner />
        </PageViewportLayout>
    );
};

export const BookEditFrameCreating: FC<{ id: string }> = ({ id }) => {
    const { t } = useTranslation();
    const theme = useTheme();

    return (
        <PageViewportLayout offsetTop={40} justify={'center'} align={'center'}>
            <FInter.MainTitleMediumDiv color={theme.projectView.titleColor}>
                {t('book_edit.frames.creating_the_book')}
            </FInter.MainTitleMediumDiv>
            <FInter.TextFlex offsetTop={16} offsetBottom={16} color={Colors.geoWhite73}>
                {t('book_edit.frames.almost_done')}
            </FInter.TextFlex>
            <FlexBox offsetBottom={16}>
            </FlexBox>
            <Spinner />
        </PageViewportLayout>
    );
};

export const BookEditFrameForbidden: FC<{ id: string }> = ({ id }) => {
    const { t } = useTranslation();

    return (
        <PageViewportLayout offsetTop={40} justify={'center'} align={'center'}>
            <ErrorPage
                title={t('book_edit.frames.something_went_wrong')}
                text={t('book_edit.frames.cannot_edit')}
            />
        </PageViewportLayout>
    );
};

import { FC } from 'react';
import { Colors, FInter, FlexBox } from '@brg/ui';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';
import { PageViewportLayout } from 'shared/components/template';
import { Spinner } from '@brg/controls';
import { ErrorPage } from 'shared/pages/error/ErrorPage';

export const BookEditFrameError: FC<{ id: string }> = ({ id }) => {
    const { t } = useTranslation();

    return (
        <PageViewportLayout offsetTop={40} justify={'center'} align={'center'}>
            <ErrorPage
                title={t('book_edit.frames.something_went_wrong')}
                text={t('book_edit.frames.cannot_edit')}
            />
        </PageViewportLayout>
    );
};

export const BookFrameError: FC<{ id: string }> = ({ id }) => {
    const { t } = useTranslation();

    return (
        <PageViewportLayout offsetTop={40} justify={'center'} align={'center'}>
            <ErrorPage
                title={t('book_edit.frames.something_went_wrong')}
                text={t('book_edit.frames.undefined')}
            />
        </PageViewportLayout>
    );
};

export const BookEditFrameUpdateError: FC<{ id: string }> = ({ id }) => {
    const { t } = useTranslation();

    return (
        <PageViewportLayout offsetTop={40} justify={'center'} align={'center'}>
            <ErrorPage
                title={t('book_edit.frames.something_went_wrong')}
                text={t('book_edit.frames.update')}
            />
        </PageViewportLayout>
    );
};

export const BookEditFrameLoading: FC<{ id: string }> = ({ id }) => {
    const { t } = useTranslation();
    const theme = useTheme();

    return (
        <PageViewportLayout offsetTop={40} justify={'center'} align={'center'}>
            <FInter.MainTitleMediumDiv color={theme.projectView.titleColor}>
                {t('book_edit.frames.loading')}
            </FInter.MainTitleMediumDiv>
            <FInter.TextFlex offsetTop={16} offsetBottom={16} color={Colors.geoWhite73}>
                {t('book_edit.frames.almost_done')}
            </FInter.TextFlex>
            <Spinner />
        </PageViewportLayout>
    );
};

export const BookEditFrameCreating: FC<{ id: string }> = ({ id }) => {
    const { t } = useTranslation();
    const theme = useTheme();

    return (
        <PageViewportLayout offsetTop={40} justify={'center'} align={'center'}>
            <FInter.MainTitleMediumDiv color={theme.projectView.titleColor}>
                {t('book_edit.frames.creating_the_book')}
            </FInter.MainTitleMediumDiv>
            <FInter.TextFlex offsetTop={16} offsetBottom={16} color={Colors.geoWhite73}>
                {t('book_edit.frames.almost_done')}
            </FInter.TextFlex>
            <FlexBox offsetBottom={16}>
            </FlexBox>
            <Spinner />
        </PageViewportLayout>
    );
};

export const BookEditFrameForbidden: FC<{ id: string }> = ({ id }) => {
    const { t } = useTranslation();

    return (
        <PageViewportLayout offsetTop={40} justify={'center'} align={'center'}>
            <ErrorPage
                title={t('book_edit.frames.something_went_wrong')}
                text={t('book_edit.frames.cannot_edit')}
            />
        </PageViewportLayout>
    );
};

